export { default } from './DisclosureRecipientCopyButton';
